import { faqModule1, faqModule2 } from "../Faq/faqDefaultModuleProp";

const faqsModule = {
  // other module props
  id: "d5f88ec5-17c2-31fc-a27d-8a48089c82ee",
  config: {
    general: {
      paddings: {
        top: true,
        bottom: true,
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: true,
      moduleBackgroundColor: {
        label: "Color 1",
        value: "#efefef",
      },
      faqBackgroundColor: {
        label: "Color 2",
        value: "#F2F6FF",
      },
      iconType: {
        label: "Math", // or Arrows
        value: "faqMath", // or faqArrows
      },
      textAlign: {
        label: "Left", // or Center
        value: "center", // or center
      },
      corners: {
        label: "Round", // or Square
        value: "round", // or square
      },
      showUnderline: true,
    },
  },
  modules: [faqModule1, faqModule2],
};

export default faqsModule;
